import { Select } from '@inflearn/ds-react-next';

import useNextUrlState from '../../hooks/useNextUrlState';

interface UrlStateSelectProps<T> {
  options: { label: string; value: T }[];
  defaultValue?: string;
  isMobile?: boolean;
}

export function UrlStateSelect<T extends string>({
  options,
  defaultValue,
  isMobile = false,
}: UrlStateSelectProps<T>) {
  const { value: query, fetchQuery } = useNextUrlState<{
    sort?: T;
  }>();

  const handleChange = (sort: string | null) => {
    if (sort === null) {
      return;
    }

    fetchQuery({ sort: sort as T });
  };

  return (
    <Select
      data={options}
      defaultValue={(defaultValue || query.sort) ?? options[0].value}
      onChange={(value: string | null) => {
        if (value === null) {
          return;
        }

        handleChange(value);
      }}
      ml="auto"
      styles={{ input: { paddingRight: 35 } }}
      size={isMobile ? 'md' : 'sm'}
    />
  );
}
